import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router)
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
	return originalPush.call(this, location).catch(err => err)
}
/* import ccc from '../pages/pc/pcindex.vue'
import ccc from '../pages/phonc/phoncindex.vue' */

	const index=()=>import('../pages/index.vue')

	const Pchome=()=>import('../pages/pc/pchome.vue')
	const Pcproduct=()=>import('../pages/pc/pcproduct.vue')
	const Pcdetails=()=>import('../pages/pc/pcdetails.vue')
	const Pcvideos=()=>import('../pages/pc/pcvideos.vue')
	const Pcquerys=()=>import('../pages/pc/pcquerys.vue')
	const Pcelites=()=>import('../pages/pc/pcelites.vue')
	const Pcshiyan=()=>import('../pages/pc/pcshiyan.vue')
	const Pccontactus=()=>import('../pages/pc/pccontactus.vue')
	const Pcabout=()=>import('../pages/pc/pcabout.vue')
	const Pcseachs=()=>import('../pages/pc/pcseachs.vue')
	const Pcvideoshiyan=()=>import('../pages/pc/videoshiyan.vue')
	const Pcamapa=()=>import('../pages/pc/amapa.vue')
	const Pcnewdetail=()=>import('../pages/pc/pcnewdetail.vue')
	const Pcfilework=()=>import('../pages/pc/pcfilework.vue')
	const Pcfallimg=()=>import('../pages/pc/pcfallimg.vue')
	const Pccourses=()=>import('../pages/pc/pccourses.vue')
	const PcWebinarDetail=()=>import('../pages/pc/pc-webinar-detail.vue')
	const PcAcademyVideos=()=>import('../pages/pc/pc-academy-videos.vue')
	const PcNews=()=>import('../pages/pc/pc-news.vue')
	const PcNewsDetail=()=>import('../pages/pc/pc-news-detail.vue')
	const PcBigStar=()=>import('../pages/pc/pc-big-star.vue')

	const Phhome=()=>import('../pages/phonc/phhome.vue')
	const Phmore=()=>import('../pages/phonc/phmore.vue')
	const Phcompany=()=>import('../pages/phonc/phcompany.vue')
	const Phlangu=()=>import('../pages/phonc/phlangu.vue')
	const Phabout=()=>import('../pages/phonc/phabout.vue')
	const Phenviron=()=>import('../pages/phonc/phenviron.vue')
	const Phhonor=()=>import('../pages/phonc/phhonor.vue')
	const Phnews=()=>import('../pages/phonc/phnews.vue')
	const Phproduct=()=>import('../pages/phonc/phproduct.vue')
	const Phdetails=()=>import('../pages/phonc/phdetails.vue')
	const Phvideos=()=>import('../pages/phonc/phvideos.vue')
	const Phcontactus=()=>import('../pages/phonc/phcontactus.vue')
	const Phelites=()=>import('../pages/phonc/phelites.vue')
	const Phquerys=()=>import('../pages/phonc/phquerys.vue')
	const Phseachs=()=>import('../pages/phonc/phseachs.vue')
	const Phceshi=()=>import('../pages/phonc/phceshi.vue')
	const Phnewdetail=()=>import('../pages/phonc/phnewdetail.vue')
	const Phfilework=()=>import('../pages/phonc/phfilework.vue')
	const Phcourses=()=>import('../pages/phonc/phcourses.vue')
	const PhAcademyVideos=()=>import('../pages/phonc/ph-academy-videos.vue')
	const PhWebinarDetail=()=>import('../pages/phonc/ph-webinar-detail.vue')
	const PhNewsA=()=>import('../pages/phonc/ph-news.vue')
	const PhNewsDetailA=()=>import('../pages/phonc/ph-news-detail.vue')
	const PhBigStar=()=>import('../pages/phonc/ph-big-star.vue')


	const routes = [
		{
			path: '/',
			name: 'Index',
			component: () => import('../pages/index.vue')
		},
		{
			path:'/pchome',
			component:Pchome,
		},
		{
			path:'/pcproduct',
			component:Pcproduct,
		},
		{
			path:'/pcdetails',
			component:Pcdetails,
		},
		{
			path:'/pcvideos',
			component:Pcvideos,
		},
		{
			path:'/pcquerys',
			component:Pcquerys,
		},
		{
			path:'/pcelites',
			component:Pcelites,
		},
		{
			path:'/pccontactus',
			component:Pccontactus,
		},
		{
			path:'/pcabout',
			component:Pcabout,
		},
		{
			path:'/pcseachs',
			component:Pcseachs,
		},
		
		{
			path:'/pcshiyan',
			component:Pcshiyan,
		},
		{
			path:'/videoshiyan',
			component:Pcvideoshiyan,
		},
		{
			path:'/amapa',
			component:Pcamapa,
		},
		{
			path:'/pcnewdetail',
			component:Pcnewdetail,
		},
		{
			path:'/pcfilework',
			component:Pcfilework,
		},
		{
			path:'/pcfallimg',
			component:Pcfallimg,
		},
		{
			path:'/pccourses',
			component:Pccourses,
		},
		{
			path:'/pc-webinar-detail',
			component:PcWebinarDetail
		},
		{
			path:'/pc-academy-videos',
			component:PcAcademyVideos
		},
		{
			path:'/pc-news',
			component:PcNews
		},
		{
			path:'/pc-news-detail',
			component:PcNewsDetail
		},
		{
			path:'/pc-big-star',
			component:PcBigStar
		},
		{
			path:'/phhome',
			component:Phhome,
		},
		{
			path:'/phmore',
			component:Phmore,
		},
		{
			path:'/phcompany',
			component:Phcompany,
		},
		{
			path:'/phlangu',
			component:Phlangu,
		},
		{
			path:'/phabout',
			component:Phabout,
		},
		{
			path:'/phenviron',
			component:Phenviron,
		},
		{
			path:'/phhonor',
			component:Phhonor,
		},
		{
			path:'/phnews',
			component:Phnews,
		},
		{
			path:'/phproduct',
			component:Phproduct,
		},
		{
			path:'/phdetails',
			component:Phdetails,
		},
		{
			path:'/phvideos',
			component:Phvideos,
		},
		{
			path:'/phcontactus',
			component:Phcontactus,
		},
		{
			path:'/phelites',
			component:Phelites,
		},
		{
			path:'/phquerys',
			component:Phquerys,
		},
		{
			path:'/phseachs',
			component:Phseachs,
		},
		{
			path:'/phceshi',
			component:Phceshi,
		},
		{
			path:'/phnewdetail',
			component:Phnewdetail,
		},
		{
			path:'/phfilework',
			component:Phfilework,
		},
		{
			path:'/pcdetails',
			component:Pcdetails,
		},
		{
			path:'/pcquerys',
			component:Pcquerys,
		},
		{
			path:'/phcourses',
			component:Phcourses,
		},
		{
			path:'/ph-academy-videos',
			component:PhAcademyVideos,
		},
		{
			path:'/ph-webinar-detail',
			component:PhWebinarDetail,
		},
		{
			path:'/ph-news',
			component:PhNewsA,
		},
		{
			path:'/ph-news-detail',
			component:PhNewsDetailA,
		},
		{
			path:'/ph-big-star',
			component:PhBigStar,
		},
	]






// if ((navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i))) {
// 	console.log('手机手机')
	
// 	routes = routesM
// } else {
// 	console.log('电脑电脑')
	
// 	routes = routesP
// }

const router = new Router({
	/* mode: 'history', */
	routes,
	scrollBehavior (to, from, savedPosition) {
		return { x: 0, y: 0 }
	}
})

export default router